/**
 * @deprecated The method should not be used. Please use the same method from internationalization.service.ts
 */
export const getLocalisedDistance = (distance: number, overrideUSRegionalSettings: boolean) => {
  return overrideUSRegionalSettings ? `${(distance * 0.621371).toFixed(1)}mi` : `${distance}km`
}
